module.exports = __webpack_public_path__ + "img/postPartum.f6e292ce.jpg";